module.exports = __webpack_public_path__ + "static/media/leaguesafe.e4bb271a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/shgn/footerLogos/mobile/leaguesafe.svg
// module id = 100
// module chunks = 0